import axios from 'axios';

const rawApiUrl = process.env.REACT_APP_API_URL;

if (!rawApiUrl || !rawApiUrl.trim()) {
  throw new Error(
    "Configuration Error: 'REACT_APP_API_URL' environment variable is missing! " +
    "Please define REACT_APP_API_URL in client/.env. " +
    "No fallback URL is provided to ensure environment variables are strictly enforced."
  );
}

export const API_BASE_URL = rawApiUrl.trim().replace(/\/+$/, '');

/**
 * Centralized Axios instance configured with base URL and JWT Bearer token injection
 */
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: inject Bearer token for authenticated requests
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || localStorage.getItem('Stafftoken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Synchronize global Axios default baseURL
axios.defaults.baseURL = API_BASE_URL;

export default apiClient;
